import React, { useCallback, useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import { debounce } from "throttle-debounce";

const Search = ({ value = '', onChange = () => { }, delay }) => {
    const [searchValue, setSearchValue] = useState(value || '');

    const onChangeDebounced = useCallback(debounce(delay || 1000, e => onChange(e)), []);

    const handleChange = e => {
        setSearchValue(e.target.value);
        onChangeDebounced(e);
    };

    useEffect(() => {
        if (value && value !== searchValue) {
            setSearchValue(value);
        }
    }, [value])

    return <FormControl
        type="text"
        value={searchValue}
        onChange={handleChange}
    />
}

export default Search;